/* Softheld Stories — the only JS the theme adds.
   1. Entrance reveals on scroll.  2. Mobile nav toggle.  3. FAQ uses native <details>, no JS. */
(function(){
  function reveals(){
    var els = document.querySelectorAll('.sh-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    },{ rootMargin:'0px 0px -8% 0px', threshold:0.08 });
    els.forEach(function(el){ io.observe(el); });
  }

  function nav(){
    document.querySelectorAll('[data-sh-nav-toggle]').forEach(function(btn){
      if(btn.dataset.shBound) return;
      btn.dataset.shBound = '1';
      btn.addEventListener('click', function(){
        var links = document.querySelector('[data-sh-nav-links]');
        if(!links) return;
        var open = links.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init(){ reveals(); nav(); }
  document.addEventListener('DOMContentLoaded', init);
  // Shopify theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
